import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MdSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/observable';
import { Subscription } from 'rxjs/Subscription';

import { Ad } from '../../enums/ad.enum';
import { ApplicationStatus } from '../../enums/application-status.enum';
import { Interest } from '../../enums/interest.enum';
import { EnumHelper } from '../../helpers/enum-helper';
import { FormHelper } from '../../helpers/form-helper';
import { Application } from '../../models/application';
import { Meetup } from '../../models/meetup';
import { ApplicationService } from '../../services/application.service';
import { AttendeeService } from '../../services/attendee.service';
import { MeetupService } from '../../services/meetup.service';

@Component({
	selector: 'app-add-application',
	templateUrl: './add-application.component.html',
	styleUrls: ['./add-application.component.scss']
})
export class AddApplicationComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	private recaptcha: firebase.auth.RecaptchaVerifier;

	public meetups: Observable<Meetup[]>;
	public enumHelper: typeof EnumHelper = EnumHelper;
	public ads: typeof Ad = Ad;
	public adValues: number[] = Object.values(Ad).filter(e => typeof (e) == "number");
	public interests: typeof Interest = Interest;
	public interestValues: number[] = Object.values(Interest).filter(e => typeof (e) == "number");

	constructor(private applicationService: ApplicationService,
		private attendeeService: AttendeeService,
		private formBuilder: FormBuilder,
		private meetupService: MeetupService,
		private router: Router,
		private snackBar: MdSnackBar,
		private dateAdapter: DateAdapter<Date>) {
		super();
		this.subscriptionManager = new Subscription();
		this.dateAdapter.setLocale('en-US');

		this.buildForm();

		this.meetups = meetupService.getNextMeetups();
		this.subscriptionManager.add(this.meetups.subscribe(next => {
			if (next.length !== 0) {
				this.form.controls['meetup'].setValue(next[0].$key);
			}
		}));
	}

	ngOnInit() {
		this.recaptcha = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
			'size': 'normal',
			'callback': (res) => {
				this.form.controls['recaptcha'].setValue(res);
			},
			'expired-callback': () => {
				this.form.controls['recaptcha'].setValue('');
			}
		});

		this.recaptcha.render();
	}

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			meetup: new FormControl('', Validators.required),
			he: new FormGroup({
				name: new FormControl('', Validators.required),
				lastname: new FormControl('', Validators.required),
				nickname: new FormControl('', Validators.required),
				phone: new FormControl('', Validators.required),
				email: new FormControl('', [Validators.required, Validators.email]),
				occupation: new FormControl('', Validators.required),
				education: new FormControl('', Validators.required)
			}),
			she: new FormGroup({
				name: new FormControl('', Validators.required),
				lastname: new FormControl('', Validators.required),
				nickname: new FormControl('', Validators.required),
				phone: new FormControl('', Validators.required),
				email: new FormControl('', [Validators.required, Validators.email]),
				occupation: new FormControl('', Validators.required),
				education: new FormControl('', Validators.required)
			}),
			address: new FormGroup({
				street: new FormControl('', Validators.required),
				exterior: new FormControl('', Validators.required),
				interior: new FormControl(),
				neighborhood: new FormControl('', Validators.required),
				zip: new FormControl('', Validators.required),
				city: new FormControl('', Validators.required),
				state: new FormControl('', Validators.required)
			}),
			couple: new FormGroup({
				marriage: new FormControl(),
				marriageYears: new FormControl(),
				catholicDate: new FormControl(new Date()),
				legalDate: new FormControl(new Date()),
				childrenNumber: new FormControl(),
				childrenNames: new FormControl(),
				childrenAges: new FormControl(),
				babysitter: new FormControl(),
				address: new FormControl(),
				phone: new FormControl()
			}),
			ad: new FormGroup({
				ad: new FormControl(),
				comment: new FormControl()
			}),
			interest: new FormGroup({
				interest: new FormControl(),
				comment: new FormControl()
			}),
			hisEmergency: new FormGroup({
				name: new FormControl('', Validators.required),
				phone: new FormControl('', Validators.required)
			}),
			herEmergency: new FormGroup({
				name: new FormControl('', Validators.required),
				phone: new FormControl('', Validators.required)
			}),
			comments: new FormControl(),
			recaptcha: new FormControl('', Validators.required)
		});
	}

	public submitForm(): void {
		this.subscriptionManager.add(this.meetups.map(ms => ms.filter(m => m.$key === this.form.value.meetup)[0]).subscribe(next => {
			const vm: Application = this.form.value;

			if (vm.couple.catholicDate != null) {
				const d: Date = vm.couple.catholicDate;
				const day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();

				vm.couple.catholicMarriageDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + day;
			}

			if (vm.couple.legalDate != null) {
				const d: Date = vm.couple.legalDate;
				const day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();

				vm.couple.legalMarriageDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + day;
			}

			delete vm.couple.catholicDate;
			delete vm.couple.legalDate;

			vm.meetupDescription = next.description;
			vm.applicationStatus = ApplicationStatus.Pending;

			this.applicationService.addApplication(vm);
			this.router.navigate(['we-got-your-application']);
		}));
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/add-application/add-application.component.ts